import { IconListDetails } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Empty, EmptyDescription, EmptyMedia } from "@/components/ui/empty";

export function SectionCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Card>
      <CardHeader className="w-full max-w-[960px] self-center pb-1">
        <SectionHeading title={title} />
      </CardHeader>
      <CardContent className="flex w-full max-w-[960px] flex-col gap-4 self-center">
        {children}
      </CardContent>
    </Card>
  );
}

export function SectionHeading({ title }: { title: string }) {
  return (
    <h2 className="flex items-center gap-2.5">
      <span aria-hidden="true" className="h-5 w-1 rounded-full bg-primary" />
      <CardTitle>{title}</CardTitle>
    </h2>
  );
}

export function CompactEmptyState() {
  const { t } = useTranslation("campaignCreation");
  return (
    <Empty className="gap-2 py-10">
      <EmptyMedia variant="icon" className="mb-2 text-muted-foreground">
        <IconListDetails />
      </EmptyMedia>
      <EmptyDescription>{t("sb.common.noData")}</EmptyDescription>
    </Empty>
  );
}
